import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Virtuoso } from 'react-virtuoso';
import EmptyData from '../../../../../shared/EmptyData';
import RenderHoldingItems from './RenderHoldingItems';

function HoldingsItems({
  holdingsData,
  template,
  controlledVocab,
  setHasError,
  hasError = false,
  onEditItem,
  onUndoStackUpdate,
  holdingsFields, // Add holdings fields
  createUndoAction, // Add undo action creator
  // Batch operations props
  selectedHoldings = [],
  onToggleSelection,
  isBatchModeActive = false,
}) {
  const renderHoldingItem = (index) => {
    const holding = holdingsData[index];
    return (
      <RenderHoldingItems
        key={`${holding.id}-${index}`}
        index={index}
        holding={holding}
        template={template}
        controlledVocab={controlledVocab}
        setHasError={setHasError}
        hasError={hasError}
        onEditItem={onEditItem}
        onUndoStackUpdate={onUndoStackUpdate}
        holdingsFields={holdingsFields} // Pass holdings fields
        createUndoAction={createUndoAction} // Pass undo action creator
        // Batch operations props
        isSelected={selectedHoldings.includes(holding.id)}
        onToggleSelection={onToggleSelection}
        isBatchModeActive={isBatchModeActive}
      />
    );
  };

  return (
    <>
      {!holdingsData.length && (
        <EmptyData
          message={
            <FormattedMessage
              id="ui-plugin-inventory-templates.instanceWizard.holdingsItems.noFields"
              defaultMessage="No holdings found, please add holdings to be able to add new items."
            />
          }
        />
      )}
      {holdingsData?.length !== 0 && (
        <div style={{ height: '90vh' }}>
          <Virtuoso
            style={{
              height: '90vh',
            }}
            totalCount={holdingsData.length}
            itemContent={renderHoldingItem}
            increaseViewportBy="200px"
          />
        </div>
      )}
    </>
  );
}

HoldingsItems.propTypes = {
  template: PropTypes.object,
  holdingsData: PropTypes.arrayOf(PropTypes.object),
  controlledVocab: PropTypes.object,
  hasError: PropTypes.bool,
  setHasError: PropTypes.func,
  onEditItem: PropTypes.func,
  onUndoStackUpdate: PropTypes.func,
  holdingsFields: PropTypes.object, // Add holdings fields prop
  createUndoAction: PropTypes.func, // Add undo action creator prop
  // Batch operations props
  selectedHoldings: PropTypes.array,
  onToggleSelection: PropTypes.func,
  isBatchModeActive: PropTypes.bool,
};

export default HoldingsItems;
